import { cn } from '~/lib/utils';

interface LogoProps {
  className?: string;
}

export const Upload = ({ className }: LogoProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(!!className && className)}
    >
      <path
        d="M12 4L12 16M12 4L9 7M12 4L15 7M4 20H20"
        stroke="#202020"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
